/* eslint semi: ["error", "never"] */
export var MAX_SESSION_TIME = 15;
export var MAX_SESSION_TIME_IN_SECONDS = moment.duration(MAX_SESSION_TIME, 'minutes').asSeconds();
export var SUPPORTED_LANGUAGES = ['ar', 'bg', 'cs', 'da', 'de', 'en', 'es', 'fi', 'fr', 'hi', 'hr', 'id', 'is', 'it', 'ja', 'ms', 'nl', 'no', 'pl', 'pt', 'ru', 'sl', 'sv', 'th', 'tr', 'zh'];
export var VALID_CARD_NUMBER_FORMAT = '^[0-9]{13,19}$';